// @ts-expect-error
import { permissionsChecker as permissionsCheckerFactory } from '@wix/communities-forum-universal/dist/src/services/permissions/forum-permission-checker';
const resourcify = (entity, resourceType) => {
    return Object.assign(Object.assign({}, (entity || {})), { getResourceId: () => resourceType });
};
const createPermissionsChecker = (permissions) => (permission, resourceType, entity) => {
    return permissions.can(resourcify(entity, resourceType), permission);
};
const createPermissionsRenderHelper = (canChecker) => (checks, render) => {
    const result = checks.map(([permission, resource, obj]) => {
        switch (resource) {
            case 'forum':
                return canChecker(permission, 'forum', obj);
            case 'category':
                return canChecker(permission, 'category', obj);
            case 'post':
                return canChecker(permission, 'post', obj);
            case 'comment':
                return canChecker(permission, 'comment', obj);
            case 'mobileSettings':
                return canChecker(permission, 'mobileSettings', obj);
            default:
                throw new Error(`Unknown resource '${resource}' for permission '${permission}' in permissions checker`);
        }
    });
    const can = result.some((r) => r);
    return can ? render(result) : null;
};
const getUserSiteMemberId = (user) => {
    if (user && user.siteMemberId) {
        return { siteMemberId: user.siteMemberId };
    }
    if (user && user.id) {
        return { siteMemberId: user.id };
    }
    return {};
};
const userToRequestor = (user, permissions) => {
    const publicUserPrivateStatuses = ['PUBLIC', 'COMMUNITY'];
    const isPublicUser = user && publicUserPrivateStatuses.includes(user.privacyStatus);
    return Object.assign(Object.assign({ permissions, groups: user && user.groups ? user.groups : [], type: isPublicUser ? 'MEMBER' : 'GUEST' }, getUserSiteMemberId(user)), (user && user.userId && { userId: user.userId }));
};
const categoryResolver = (resolveCategory) => (resource) => {
    if (resource.categoryId) {
        resource = resolveCategory(resource.categoryId);
    }
    return resource;
};
const permissionsChecker = permissionsCheckerFactory();
export const createPermissionCheckerClientAPI = ({ user, usersPermissions, getCategory, }) => {
    const requestor = userToRequestor(user, usersPermissions);
    const permissions = permissionsChecker.withContext(requestor, categoryResolver(getCategory));
    const canPermissionsHelper = createPermissionsChecker(permissions);
    const permissionsRenderHelper = createPermissionsRenderHelper(canPermissionsHelper);
    return {
        permissions,
        can: canPermissionsHelper,
        canRender: permissionsRenderHelper,
    };
};
//# sourceMappingURL=permission-checker-client-api.js.map